import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-xs-center"},[_c('div',[(_vm.loading)?_c('div',[_c('h3',[_c(VProgressCircular,{staticClass:"mr-1",attrs:{"indeterminate":"","color":"primary"}}),_vm._v("\n                Loading...\n            ")],1)]):_vm._e(),_c('qrcode-stream',{staticClass:"element",on:{"decode":_vm.onDecode,"init":_vm.onInit}}),_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }